import styled from 'styled-components';


const CriteriaWrapperColRight = styled.div`
  @media (min-width: 1124px) {
    width: 48%;
  }
  width: 100%;
  height: 100%;
  margin-bottom: 24px;
  // padding-right: 5px;
`;

export default CriteriaWrapperColRight;